import PageDescription from './PageDescription.jsx';
import PageHeader from './PageHeader.jsx';
import PageSection from './PageSection.jsx';
import PageTitle from './PageTitle.jsx';
import PageWrapperWithNav from './PageWrapperWithNav.jsx';

const PageCard = ({ title, description, returnLabel, returnRoute, children }) => {
  return (
    <PageWrapperWithNav
      header={
        <PageHeader>
          <PageTitle returnLabel={returnLabel} returnRoute={returnRoute}>
            {title}
          </PageTitle>
          {description && <PageDescription>{description}</PageDescription>}
        </PageHeader>
      }>
      <PageSection variant={'chromeless'} className="comp-page-card">
        {children}
      </PageSection>
    </PageWrapperWithNav>
  );
};

export default PageCard;
